import React from 'react';

import {Link} from "react-router-dom";
import {Card, Typography} from "@mui/material";
import {sx} from "./sx";
import {useTranslation} from "react-i18next";
import {classNames} from "@helpers/classNames";
import {IReportNavigateItemSingleVoyage} from "@pages/singleVoyage/reports/allReports/types";

interface IProps extends IReportNavigateItemSingleVoyage {
    active: boolean
}

const ReportNavigateItemSingleVoyage = ({
                                            path,
                                            label,
                                            active
                                        }: IProps) => {

    const {t} = useTranslation()

    return (
        <Link to={path}>
            <Card
                className={classNames(active && 'active')}
                sx={sx.root}
            >
                <Typography
                    sx={sx.name}
                    className={classNames(active && 'active')}

                >
                    {t(label)}
                </Typography>
            </Card>
        </Link>
    );
};

export default ReportNavigateItemSingleVoyage;